import { Outlet } from 'react-router';

import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';

import { MaintenanceMode } from './MaintenanceMode';

export const MaintenanceGate = () => {
  const isMaintenanceMode = useFlag(FeatureFlag.MaintenanceModeEnabled);
  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }
  return <Outlet />;
};
